import { css } from 'lit';
const EDITOR_UUID = 'session-editor-uuid';

const DUPLICATE_TAB_NAVIGATION_TYPE = 'back_forward';

/**
 * @returns {string} - UUID for current user session
 */
export function getSessionUUID(): string {
	let editorUUid = window.sessionStorage.getItem(EDITOR_UUID);
	if (!editorUUid) {
		editorUUid = crypto.randomUUID();
		window.sessionStorage.setItem(EDITOR_UUID, editorUUid);
	}
	return editorUUid;
}

/**
 * Initializes session for uuid by checking for tab duplication
 */
export function initSessionUUID(): void {
	const [navigationEntry] = window.performance.getEntriesByType(
		'navigation',
	) as PerformanceNavigationTiming[];

	if (navigationEntry?.type === DUPLICATE_TAB_NAVIGATION_TYPE) {
		window.sessionStorage.clear();
	}
}
